import { createContext } from 'react';

export const LastAnswersContext = createContext([]);
